export default function isMediaFilePath(path: string): boolean {
  return /\.(html|pdf|img|png|jpg|jpeg|svg|ico|mp4)\/?$/.test(path);
}
